module.exports = "mutation saveAdviceRequest($adviceRequest:SaveAdviceRequestInput!){saveAdviceRequest(adviceRequest:$adviceRequest)}"